import { VideosComponent } from './videos.component'
import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { MetaGuard } from 'meta'
import { VideosResolver } from './videos.resolver'
import { VIDEO_TAG } from './videos-analytics.service'
import { pathMatcher } from '../shared/utility-functions/slug.utility'
import { CORE_ID_RULES } from '../shared/utility-functions/regex.utility'

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        matcher: url => pathMatcher(url, 'slug', CORE_ID_RULES),
        resolve: { node: VideosResolver },
        component: VideosComponent,
        canActivate: [MetaGuard],
        data: {
          /**
           * This will both prevent automatic page calls and also allow the
           * analytics directive to work.
           *
           * @see outExcludedRoutes
           */
          segment: VIDEO_TAG,
          shouldShowAdSkin: false,
          shouldShowEventTicker: true,
          meta: {
            title: 'meta_videos_page_title',
            description: 'meta_videos_page_description',
            'og:type': 'meta_videos_page_page_type'
          }
        }
      }
    ])
  ],
  exports: [RouterModule]
})
export class VideosRoutingModule {}
